<div class="header-container" data-testid="navigation">
  <div class="header-banner clear-fix">
    <div class="pull-left">
      <a (click)="handleIconClick()" [ngClass]="{ 'has-for-xyz': true }">
        <img class="brand-logo" alt="MCTrade Logo" src="/assets/img/Momentive-MC-Trade-Logo-Color.svg" data-testid="atlas-logo" />

        <span class="for-xyz on-interior"></span>
      </a>
    </div>
    <div class="pull-right header-user-nav">
      <div data-wc-helpid="156" class="version-badge"></div>
      <ul class="list-inline wc-webClientCustomTopNavigation">
        <li>
          <div class="visible-lg visible-md visible-sm" [hidden]="!showLogout || !userName">
            <div class="dropdown">
              <span class="btn btn-default t-dark dropdown-toggle" (click)="toggleDropdown($event)"
                data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">{{ userName }} <span
                  class="caret"></span></span>
              <ul class="dropdown-menu dropdown-menu-right">
                <li>
                  <a href="#" (click)="$event.preventDefault(); logout()">{{ 'common.logout' | translate }}</a>
                </li>
              </ul>
            </div>
          </div>
        </li>
        <li>
          <a data-wc-ga-event-category="Help Link" target="_blank" href="https://atlas.memberclicks.com"
            data-testid="help-link">{{
            'shared.container.top-nav.component.menu.help.header' | translate
            }}</a>
        </li>
      </ul>
    </div>
    <div class="header-assoc-name" *ngIf="!showTenantSelection">{{ assocName }}</div>
    <div class="header-assoc-name" style="cursor: pointer" *ngIf="showTenantSelection" (click)="showTenantModal = true">
      <span>{{ assocName }}</span>
    </div>
  </div>
</div>

<!-- Sticky, and a sibling of the banner rather than inside it, so it pins for the whole page (see top-nav.component.css) -->
<div class="wl-top-fixed-bar-container" [ngClass]="sectionName" [class.affix]="affix">
  <p-menubar [model]="menubarItems" styleClass="wl-main-navbar" data-testid="navigation">
    <ng-template pTemplate="start">
      <div class="navbar-brand-container"><a class="navbar-brand" href="/v12/webclient/index.aspx"></a></div>
      <div class="navbar-assoc-name">{{ assocName }}</div>
    </ng-template>
    <ng-template pTemplate="end">
      <div class="nav-bar-extra-nav">
        <ul class="list-inline">
          <li [hidden]="!showLogout || !userName">
            <div class="dropdown">
              <span class="btn dropdown-toggle" (click)="toggleDropdown($event)" role="button" aria-haspopup="true" aria-expanded="false">
                {{ userName }} <span class="caret"></span>
              </span>
              <ul class="dropdown-menu dropdown-menu-right">
                <li><a href="#" (click)="$event.preventDefault(); logout()">{{ 'common.logout' | translate }}</a></li>
              </ul>
            </div>
          </li>
          <li>
            <a data-wc-ga-event-category="Help Link" target="_blank" class="wl-top-help-no-bg" href="https://atlas.memberclicks.com">
              {{ 'shared.container.top-nav.component.menu.help.header' | translate }}
            </a>
          </li>
        </ul>
      </div>
    </ng-template>
  </p-menubar>
  <wl-module-toolbar (sectionChange)="sectionName = $event"></wl-module-toolbar>
</div>
<wl-events-new> </wl-events-new>
<wl-events-v4-new> </wl-events-v4-new>
<wl-profile-create> </wl-profile-create>
<wl-admin-http-request-items #httpRequestItemsDialog> </wl-admin-http-request-items>

<!-- <wl-user-password-change [(showRequired)]="showForcePasswordUpdate" [userNum]="userNum"></wl-user-password-change> -->

<p-dialog [visible]="showTenantModal" (visibleChange)="showTenantModal = $event" [closable]="false" modal="true"
  blockScroll="true" draggable="false" styleClass="atlas-dialog-m" position="top">
  <ng-template pTemplate="header">
    <h4>{{ 'shared.container.top-nav.tenant-switcher.header' | translate }}</h4>
  </ng-template>
  <div class="mb-10">
    <p>{{ 'shared.container.top-nav.tenant-switcher.instructions' | translate }}</p>
    <p>
      <strong>{{ 'shared.container.top-nav.tenant-switcher.please-note' | translate | uppercase }}</strong>
      {{ 'shared.container.top-nav.tenant-switcher.warning' | translate }}
    </p>
  </div>
  <p-autocomplete #autoComplete name="tenantSelection" appendTo="body" field="label" [(ngModel)]="selectedTenant"
    [suggestions]="tenantSearchResults" (onSelect)="tenantSelected($event)" (completeMethod)="searchTenants($event)"
    placeholder="{{ 'shared.container.top-nav.tenant-switcher.placeholder' | translate }}"></p-autocomplete>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="atlas-btn atlas-btn-secondary" (click)="showTenantModal = false">
      {{ 'common.cancel' | translate | uppercase }}
    </button>
    <button type="button" class="atlas-btn atlas-btn-primary ml-10" (click)="switchTenant()"
      [disabled]="selectedTenant == null || isSwitching">
      <wl-busy [show]="isSwitching" class="mr-5"></wl-busy>
      <span [hidden]="isSwitching">{{ 'shared.container.top-nav.tenant-switcher.switch' | translate | uppercase
        }}</span>
      <span [hidden]="!isSwitching">{{ 'shared.container.top-nav.tenant-switcher.switching' | translate | uppercase
        }}</span>
    </button>
  </ng-template>
</p-dialog>

<p-dialog [visible]="showTenantContextChangedModal" [closable]="false" modal="true" blockScroll="true"
  draggable="false" styleClass="atlas-dialog-m" position="top">
  <ng-template pTemplate="header">
    <h4>{{ 'shared.container.top-nav.tenant-context-changed.header' | translate }}</h4>
  </ng-template>
  <div class="mb-10">
    <p>{{ 'shared.container.top-nav.tenant-context-changed.body' | translate }}</p>
  </div>
  <ng-template pTemplate="footer">
    <button type="button" class="atlas-btn atlas-btn-primary" (click)="reloadApp()">
      {{ 'shared.container.top-nav.tenant-context-changed.reload' | translate | uppercase }}
    </button>
  </ng-template>
</p-dialog>
